"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const statRuleNative_1 = require("./statRuleNative");
const wmLogger_1 = require("../../lib/wmLogger");
const expoSensor_1 = require("../../lib/expoSensor");
let loaded;
const adTargets = {};
const slotids = new Set();
class NativeAds extends React.Component {
    constructor(props) {
        super(props);
        this.ref = null;
        this.ref = React.createRef();
        wmLogger_1.WmLogger.getRuleManager().setRules(statRuleNative_1.default);
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.slotId === this.props.slotId) {
            return false;
        }
    }
    componentDidMount() {
        slotids.add(this.props.slotId);
        this.adLoaded();
        adTargets['ads-' + this.props.pos] = this; // 先将this保存起来，native ad change时使用
        if (loaded) {
            return;
        }
        document.addEventListener('native_ad:change', (event) => {
            console.log('native ad', event);
            try {
                if (event.data.id) {
                    const _this = adTargets[event.data.id];
                    const $obj = document.getElementById(`${event.data.id}`);
                    if (event.data.height === '0px') {
                        $obj.remove();
                        _this.adLoadFail({ errMsg: 'height===0px' }); // 广告加载失败
                    }
                    else {
                        let height = event.data.height;
                        if (typeof height === 'string') {
                            // 兼容native广告客户端高度显示问题
                            const h = parseInt(height.match(/\d+/g)[0], 10);
                            if (h > 120) {
                                height = h + 15 + 'px';
                            }
                        }
                        $obj.style.opacity = '1';
                        $obj.style.height = height;
                        _this.adLoadSuccess(); // 广告加载成功
                    }
                }
                else {
                    // alert('没有回调id')
                    this.adLoadFail2({ errMsg: '没有回调id' });
                }
            }
            catch (e) {
                const id = event.data && event.data.id;
                //   alert('出错了')
                this.adLoadFail2({
                    code: e.errCode ? e.errCode : '',
                    errMsg: e.errMeg ? e.errMeg : '',
                    pos: id || '',
                });
            }
        });
        loaded = true;
    }
    render() {
        const { pos, slotId, cpid, articleid, ch_id1 } = this.props;
        return (React.createElement("div", { ref: this.ref, onClick: () => {
                this.clickLog();
            } },
            React.createElement("object", { id: 'ads-' + pos, type: "application/view", style: { width: '100%', height: 0, opacity: 0 } },
                React.createElement("param", { name: "native_type", value: "iflow_ad" }),
                React.createElement("param", { name: "channel", value: ch_id1 }),
                React.createElement("param", { name: "articleid", value: articleid }),
                React.createElement("param", { name: "cpid", value: cpid }),
                React.createElement("param", { name: "slotid", value: slotId }),
                React.createElement("param", { name: "is_use_cache", value: "true" }))));
    }
    // 广告组件挂载
    adLoaded() {
        // console.log('广告组件挂载');
        const { slotId, pos } = this.props;
        wmLogger_1.WmLogger.log({
            placement_id: slotId,
            pos,
        }, 'apply_ads');
    }
    // 广告加载成功
    adLoadSuccess() {
        this.listenExpo(); // 挂载成功后再监听
        const { slotId, pos } = this.props;
        wmLogger_1.WmLogger.log({
            adsId: '',
            adsTitle: '',
            advertiser: '',
            placement_id: slotId,
            pos,
        }, 'pull_ads');
    }
    // 广告加载失败
    adLoadFail(e) {
        const { slotId, pos } = this.props;
        wmLogger_1.WmLogger.log({
            code: e.errCode ? e.errCode : '',
            msg: e.errMsg ? e.errMsg : '',
            placement_id: slotId,
            pos,
        }, 'fail_ads');
    }
    // 广告加载失败，无法得知具体失败信息
    adLoadFail2(e) {
        wmLogger_1.WmLogger.log({
            code: e.errCode || '',
            msg: e.errMsg || '',
            placement_id: [...slotids].join(','),
            pos: e.pos || '',
        }, 'fail_ads');
    }
    // 统计广告曝光
    listenExpo() {
        expoSensor_1.default.addHook({
            el: this.ref.current,
            onExpo: () => {
                const { slotId, pos } = this.props;
                if (!slotId) {
                    return;
                }
                setTimeout(() => {
                    wmLogger_1.WmLogger.log({
                        adsId: '',
                        adsTitle: '',
                        advertiser: '',
                        placement_id: slotId,
                        pos,
                    }, 'show_ads');
                }, 500);
            },
        });
    }
    // 广告点击统计
    clickLog() {
        const { slotId, pos } = this.props;
        wmLogger_1.WmLogger.log({
            adsId: '',
            adsTitle: '',
            advertiser: '',
            placement_id: slotId,
            pos,
        }, 'click_ads');
    }
}
exports.default = NativeAds;
//# sourceMappingURL=data:application/json;base64,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